import { Anchor, Flex, Text } from '@mantine/core';
import { formatStringDateToRelative } from '@dealstack/shared/lib/format/dates/date.ts';
import { useTranslationCapManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.tsx';
import { useBasicDetailsHistoryLink } from './useBasicDetailsHistoryLink.ts';

const BULLET = '•';

export const BasicDetailsHistoryLink = () => {
	const tCapManage = useTranslationCapManage();
	const { lastBasicDetailsAudit, goToHistory } = useBasicDetailsHistoryLink();

	const relativeTime = lastBasicDetailsAudit
		? formatStringDateToRelative(lastBasicDetailsAudit.createdAt)
		: undefined;

	return (
		<Flex bg="white" w="100%">
			<Flex align="center" wrap="wrap" gap="0.25rem" p="0.5rem">
				{lastBasicDetailsAudit && (
					<Text size="sm" c="dark.0">
						{tCapManage('people.history.last_updated_by', {
							defaultValue: 'Basic details last updated by',
						})}{' '}
						<Text span fw={600} c="dark.0">
							{lastBasicDetailsAudit.userDisplayName ??
								tCapManage('people.history.system_actor', {
									defaultValue: 'System',
								})}
						</Text>
						{relativeTime ? ` ${BULLET} ${relativeTime} ` : ' '}
						{BULLET}
					</Text>
				)}
				<Anchor
					component="button"
					type="button"
					size="sm"
					fw={600}
					c="blue.6"
					onClick={goToHistory}
				>
					{tCapManage('people.details.view_history', {
						defaultValue: 'View history',
					})}
				</Anchor>
			</Flex>
		</Flex>
	);
};
